<template>
  <div class="main-container" @scroll="scroll">
    <My-new-nav ref="header"></My-new-nav>
      <div>
        <div class="view-bg-black" id="homeCooperation">
          <div class="view-width view-pt-68">
            <ecn-title title="部分合作伙伴" message="携手合作伙伴, 共建医疗新生态, 共赢未来"></ecn-title>
            <div class="home-cooperation">
              <div class="home-cooperation-item" v-for="(item, i) in enterpriseList" :key="i">
                <img :src="item.imgUrl" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img style="display: none" :src="bgImg" @load="onBgImgLoad" />
      <My-new-footer></My-new-footer>
    <!-- </keep-alive> -->
  </div>
</template>
<script>
import { selectEnterpriseList } from "../../../common/api";
import scrollHeaderStyle from "../newJoinus/utils";
export default {
  name: "partner",
  data() {
    return {
      enterpriseList: [],
      scrollTop: 0,
      bgImg: require("../../assets/image/new_home-banner.png"),
    };
  },

  mounted() {
    this.getCoopEnterpriseList();
  },
  activated(){
    console.log('$route.params.detail', this.$route.params.isNewDetail)
    if(this.$route.params.isNewDetail){
      //利用自定义属性来判断
      document.querySelector('.main-container').scrollTop = this.scrollTop
    }else{
       document.querySelector('.main-container').scrollTop = 0
    }
    let context = this;
    scrollHeaderStyle(0, context, this.pageType )
  },
  methods: {
    onBgImgLoad() {
      document.getElementById("homeCooperation").style.backgroundImage = `linear-gradient(180deg, transparent, #000), url(${this.bgImg})`;
    },
    getCoopEnterpriseList() {
      let data = {
        isOfficial: 1,
        pageIndex: 1,
        pageSize: 10000,
      };
      selectEnterpriseList(data).then((res) => {
        if (res.responseCode == 0) {
          this.enterpriseList = res.responseBody;
        }
      });
    },
    scroll(e){
      //滚动条滚动的事件
      let context = this;
      scrollHeaderStyle(e.srcElement.scrollTop, context, this.pageType )
    }
  },
};
</script>

<style lang="scss" scoped>
.view-bg-black{
  height: auto;
  padding-top: 80px;
}
#homeCooperation{
  width: 100%;
  background-image: linear-gradient(180deg, transparent, #000), url('../../assets/image/new_home-banner_compress.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.home-cooperation {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  font-size: 0;
  margin-top: 50px;
  background: url('../../assets/image/footer-binner.png') no-repeat bottom;
  background-size: 100%;
  padding-bottom: 108px;
}
.home-cooperation-item {
  width: 240px;
  height: 128px;
  margin: 0 20px 20px 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border-radius: 8px;
  &:nth-child(5n){
    margin-right: 0;
  }
  img {
    width: 100%;
    height: 1005;
  }
  .more-item {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 18px;
    color: #888888;
    letter-spacing: 2px;
    img {
      width: 16px;
      height: 16px;
      margin-left: 5px;
    }
  }
}
</style>

